import React, { useRef, useState } from "react";
import "./ContactForm.scss";
import emailjs from "@emailjs/browser";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormScheme } from "../../../../validation/FormScheme";

const ContactForm = () => {
  const [state, setState] = useState({
    name: "",
    email: "",
    message: "",
  });
  const form = useRef();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(FormScheme) });
  const sendEmail = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    emailjs.sendForm(
      "service_wctciuh",
      "template_92frgki",
      form.current,
      "IsVmnC1ug2Pt0INAd"
    );
    setState({
      name: "",
      email: "",
      message: "",
    });
  };

  const handleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  return (
    <form ref={form} onSubmit={handleSubmit(sendEmail)}>
      <div className="row form-inner">
        <div data-aos="fade-right" className="col-lg-6 col-md-12">
          <input
            {...register("name")}
            onChange={handleChange}
            value={state.name}
            type="text"
            name="name"
            placeholder="Name"
          />
          {errors.name ? (
            <span className="error">{errors.name.message}</span>
          ) : (
            <></>
          )}
        </div>
        <div data-aos="fade-right" className="col-lg-6 col-md-12">
          <input
            {...register("email")}
            onChange={handleChange}
            value={state.email}
            type="email"
            name="email"
            placeholder="Email"
          />
          {errors.email ? (
            <span className="error">{errors.email.message}</span>
          ) : (
            <></>
          )}
        </div>
        <div data-aos="fade-right" className="col-lg-12 col-md-12">
          <textarea
            {...register("message")}
            onChange={handleChange}
            value={state.message}
            name="message"
            cols="30"
            rows="10"
            placeholder="Message"
          ></textarea>
          {errors.message ? (
            <span className="error">{errors.message.message}</span>
          ) : (
            <></>
          )}
        </div>
        <div className="col-lg-4 col-md-6 col-sm-12">
          <button type="submit">Send Message</button>
        </div>
      </div>
    </form>
  );
};

export default ContactForm;
